<template>
  <div class="row">
    <div class="col-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="card-title mb-4" v-if="addNewRelease">
            {{ form.prd_name }}({{ form.prd_product_line }})
          </div>
          <BForm @submit.prevent="onSubmit">
            <div class="row">
              <div class="form-group col-md-6" v-if="!addNewRelease">
                <label for="InputProductName"
                  >Product <span class="mandatory-sign">*</span></label
                >
                <BFormInput
                  id="inline-form-input-name"
                  v-model="form.prd_name"
                  class="form-control form-control-lg"
                  placeholder="Product Name"
                  :state="is_valid_product_name"
                  aria-describedby="input_error_product_name"
                />
                <BFormInvalidFeedback id="input_error_product_name">
                  Enter Product Name
                </BFormInvalidFeedback>
              </div>

              <div class="form-group col-md-6" v-if="!addNewRelease">
                <label for="InputProductLine"
                  >Product Line<span class="mandatory-sign">*</span></label
                >
                <BFormSelect
                  class="form-control form-select form-control-lg"
                  v-model="form.prd_product_line"
                  :options="ddlProductLines"
                  :state="is_valid_product_line"
                  aria-describedby="intpur_error_product_line"
                />
                <BFormInvalidFeedback id="intpur_error_product_line">
                  Select Product Line
                </BFormInvalidFeedback>
              </div>

              <!-- <div class="form-group col-md-6" v-if="!addNewRelease">
                <label for="InputProductLine"
                  >Product Line<span class="mandatory-sign">*</span></label
                >
                <BFormInput
                  id="inline-form-input-line"
                  v-model="form.prd_product_line"
                  class="form-control form-control-lg"
                  placeholder="Product Line"
                  :state="is_valid_product_line"
                  aria-describedby="input_error_product_line"
                />
                <BFormInvalidFeedback id="input_error_product_line">
                  Enter Product Line
                </BFormInvalidFeedback>
              </div> -->

              <div class="form-group col-md-6">
                <label for="exampleInputEmail3"
                  >Latest Firmware
                  <span class="mandatory-sign" v-if="addNewRelease"
                    >*</span
                  ></label
                >
                <BFormInput
                  id="inline-form-input-name"
                  v-model="form.prd_latest_firmware"
                  class="form-control form-control-lg"
                  placeholder="Latest Firmware"
                  :state="is_valid_firmware_version"
                  aria-describedby="input_error_firmware_version"
                />
                <BFormInvalidFeedback id="input_error_firmware_version">
                  Enter Latest Firmware Version
                </BFormInvalidFeedback>
              </div>
              <div class="form-group col-md-6">
                <label for="exampleInputPassword4"
                  >Latest Version
                  <span class="mandatory-sign" v-if="addNewRelease"
                    >*</span
                  ></label
                >
                <BFormInput
                  id="inline-form-input-name"
                  v-model="form.prd_latest_version"
                  class="form-control form-control-lg"
                  placeholder="Latest Version"
                  :state="is_valid_relased_version"
                  aria-describedby="input_error_relased_version"
                />
                <BFormInvalidFeedback id="input_error_relased_version">
                  Enter Latest Released Version
                </BFormInvalidFeedback>
              </div>
              <div class="form-group col-md-6">
                <label for="exampleInputPassword4"
                  >Release Date
                  <span class="mandatory-sign" v-if="addNewRelease"
                    >*</span
                  ></label
                >
                <div></div>
                <BFormInput
                  type="date"
                  id="inline-form-input-prn_created_on"
                  v-model="release_note_form.prn_release_date"
                  class="form-control form-control-lg"
                  :state="is_valid_release_date"
                  placeholder="Select Release Date "
                  :min="min"
                  :max="max"
                />

                <!-- <BFormInvalidFeedback id="input_error_relased_version">
                  Select Release Date
                </BFormInvalidFeedback> -->

                <BFormInvalidFeedback
                  id="input_error_relased_version"
                  style="display: block"
                  v-if="
                    release_date_val_msg != null &&
                    is_valid_release_date != null &&
                    !is_valid_release_date
                  "
                >
                  {{ release_date_val_msg }}
                </BFormInvalidFeedback>
              </div>

              <div class="form-group col-md-6 col-xs-12">
                <label
                  >Release Note Document
                  <span class="mandatory-sign" v-if="addNewRelease"
                    >*</span
                  ></label
                >
                <div class="input-group col-xs-12">
                  <input
                    type="file"
                    class="form-control file-upload-info"
                    placeholder="Select File"
                    ref="inputFileRef"
                    @change="selectedFile"
                    aria-describedby="input_error_file"
                    accept=".docx, .doc, .pdf, .txt, .xlsx,
                                        .xls, .csv"
                    :aria-invalid="!is_valid_file"
                  />
                  <span class="input-group-append">
                    <a
                      class="file-upload-browse btn btn-gradient-primary"
                      type="button"
                      @click="$refs.inputFileRef.click()"
                      ><i class="mdi mdi mdi-attachment mdi-24px"></i
                    ></a>
                  </span>
                  <BFormInvalidFeedback
                    id="input_error_file"
                    style="display: block"
                    v-if="is_valid_file != null && !is_valid_file"
                  >
                    Select File
                  </BFormInvalidFeedback>
                </div>
                <div>
                  <p style="color: #047edf; font-size: 0.875rem">
                    Note: Upload the file in following format only: .docx, .doc,
                    .pdf, .txt, .xlsx, .xls, .csv and maximum upload file size
                    is 25MB.
                  </p>
                </div>
              </div>
              <div class="mt-3">
                <BButton
                  class="btn btn-block btn-gradient-primary btn-lg font-weight-medium auth-form-btn"
                  type="submit"
                  >Submit</BButton
                >
                <BButton class="btn btn-light" @click="cancel">Cancel </BButton>
              </div>
            </div>
          </BForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { toast } from "vue3-toastify";
import { ref } from "vue";
import { useLoading } from "vue-loading-overlay";

const $loading = useLoading();

const is_valid_product_name = null;
const is_valid_product_line = null;
const is_valid_firmware_version = null;
const is_valid_relased_version = null;
const is_valid_file = null;
const input_obj = { obj_product: {}, obj_release_note: {} };
const selected_file = null;
const loading = false;
const release_date_val_msg = "Select Release Date";

// const minDate = new Date();
// const maxDate = new Date();

const allowedFileFormats = ["pdf", "xlsx", "xls", "csv", "txt", "docx", "doc"];

const ddlProductLines = [
  { value: "-1", text: "Select Product Line" },
  { value: "Guiding", text: "Guiding" },
  { value: "Winding", text: "Winding" },
  { value: "Tension Control", text: "Tension Control" },
  { value: "Others", text: "Others" },
];

const inputFileRef = ref(null);

export default {
  name: "manage-product-release",
  props: {
    objProductRelease: {},
    addNewRelease: Boolean,
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    // 15th two months prior
    const minDate = new Date(today);
    minDate.setMonth(minDate.getMonth() - 2);
    minDate.setDate(15);
    // 15th in two months
    const maxDate = new Date(today);
    maxDate.setMonth(maxDate.getMonth() + 2);
    maxDate.setDate(15);
    return {
      ddlProductLines,
      // user,
      form: {
        prd_id: this.objProductRelease.prd_id,
        prd_name: this.objProductRelease.prd_name,
        prd_status: this.objProductRelease.prd_status,
        prd_latest_firmware: this.addNewRelease
          ? ""
          : this.objProductRelease.prd_latest_firmware,
        prd_latest_version: this.addNewRelease
          ? ""
          : this.objProductRelease.prd_latest_version,
        prd_created_on: this.objProductRelease.prd_created_on, //format((this.objProductRelease.prd_created_on)),//, 'yyyy-MM-dd hh:mm:ss'),
        prd_created_by: this.objProductRelease.prd_created_by,
        prd_modified_on: this.objProductRelease.prd_modified_on,
        prd_modified_by: this.objProductRelease.prd_modified_by,
        prd_product_line: this.objProductRelease.prd_product_line,
      },
      release_note_form: {
        prn_id: null,
        prn_prd_id: this.objProductRelease.prd_id,
        prn_file_name: "",
        prn_file_location: "",
        prn_file_size: "",
        prn_created_on: new Date(),
        prn_created_by: this.objProductRelease.prd_created_by, //user.usr_id,
        prn_firmware: "",
        prn_version: "",
        prn_release_date: null,
      },
      is_valid_product_name,
      is_valid_firmware_version,
      is_valid_relased_version,
      is_valid_file,
      inputFileRef,
      input_obj,
      selected_file,
      loading,
      allowedFileFormats,
      is_valid_product_line,
      min: minDate,
      max: maxDate,
      $loading,
      release_date_val_msg,
    };
  },
  methods: {
    async onSubmit() {
      if (this.validateFormInput()) {
        let loader = this.$loading.show();

        if (this.selected_file != null) {
          await this.uploadFile();
          loader.hide();
        } else {
          await this.manage_product_detail();
          loader.hide();
        }
      }
    },
    async manage_product_detail() {
      this.release_note_form.prn_firmware = this.form.prd_latest_firmware;
      this.release_note_form.prn_version = this.form.prd_latest_version;

      this.input_obj.obj_product = this.form;
      this.input_obj.obj_release_note =
        this.selected_file != null ? this.release_note_form : null;
      axios
        .post("/manage_product_detail", this.input_obj)
        .then((res) => {
          if (res.data != null) {
            toast(res.data.message, {
              autoClose: 2000,
              theme: "colored",
              type: "success",
              position: "bottom-left",
              dangerouslyHTMLString: true,
            });
            this.$emit("is_cance_clicked", true);
          }
        })
        .catch((err) => {
          toast(err.response.data.detail, {
            autoClose: 2000,
            theme: "colored",
            type: "error",
            position: "bottom-left",
            dangerouslyHTMLString: true,
          });
        });
    },
    cancel() {
      this.$emit("is_cance_clicked", true);
    },
    validateFormInput() {
      this.is_valid_product_name =
        this.form.prd_name == "" || this.form.prd_name == "-1" ? false : true;
      this.is_valid_product_line =
        this.form.prd_product_line == "" || this.form.prd_product_line == "-1"
          ? false
          : true;
      if (this.addNewRelease) {
        this.is_valid_firmware_version =
          this.form.prd_latest_firmware == "" ? false : true;
        this.is_valid_relased_version =
          this.form.prd_latest_version == "" ? false : true;
        this.is_valid_file =
          this.selected_file == undefined || this.selected_file == null
            ? false
            : true;
        this.is_valid_release_date =
          this.release_note_form.prn_release_date == null ? false : true;
        if (
          !this.is_valid_firmware_version ||
          !this.is_valid_relased_version ||
          !this.is_valid_release_date ||
          !this.is_valid_file
        ) {
          return false;
        }
      }

      if (this.release_note_form.prn_release_date != null) {
        const today = new Date();
        const selected = new Date(this.release_note_form.prn_release_date);
        today.setHours(0, 0, 0, 0);
        selected.setHours(0, 0, 0, 0);

        if (selected > today) {
          this.is_valid_release_date = false;
          this.release_date_val_msg = "Cannot select future date.";
          return false;
        } else {
          this.is_valid_release_date = true;
          this.release_date_val_msg = "";
        }
      }

      if (!this.is_valid_product_name) return false;
      return true;
    },
    selectedFile(event) {
      this.release_note_form.prn_file_size = "";
      this.selected_file = null;
      if (event.target.files[0] != null) {
        let arr = event.target.files[0].name.split(".");

        const selectedFileFrmat =
          event.target.files[0].name.split(".")[arr.length - 1];

        if (!allowedFileFormats.includes(selectedFileFrmat)) {
          toast("Please Select valid file format.", {
            autoClose: 2000,
            theme: "colored",
            type: "error",
            position: "bottom-left",
            dangerouslyHTMLString: true,
          });
          return;
        }

        this.release_note_form.prn_file_size =
          event.target.files[0].size.toString();
        this.selected_file = event.target.files[0];
      }

      // this.release_note_form.prn_file_name = event.target.files[0].name
    },

    async uploadFile() {
      var formData = new FormData();
      let loader = this.$loading.show();
      formData.append("file", this.selected_file);
      formData.append("prd_name", this.form.prd_name);
      await axios
        .post("/upload_files", formData)
        .then((res) => {
          loader.hide();
          this.release_note_form.prn_file_name =
            res.data.uploaded_file.file_name;
          this.release_note_form.prn_file_location =
            res.data.uploaded_file.file_path;
          if (this.addNewRelease) this.manage_product_release();
          else this.manage_product_detail();
        })
        .catch((err) => {
          loader.hide();
          toast(err.response.data.detail, {
            autoClose: 2000,
            theme: "colored",
            type: "error",
            position: "bottom-left",
            dangerouslyHTMLString: true,
          });
        });
    },

    async manage_product_release() {
      let loader = this.$loading.show();
      this.release_note_form.prn_firmware = this.form.prd_latest_firmware;
      this.release_note_form.prn_version = this.form.prd_latest_version;
      axios
        .post("/manage_product_release", this.release_note_form)
        .then((res) => {
          if (res.data != null) {
            loader.hide();
            toast(res.data.message, {
              autoClose: 2000,
              theme: "colored",
              type: "success",
              position: "bottom-left",
              dangerouslyHTMLString: true,
            });
            this.$emit("is_cance_clicked", true);
          }
        })
        .catch((err) => {
          loader.hide();
          toast(err.response.data.detail, {
            autoClose: 2000,
            theme: "colored",
            type: "error",
            position: "bottom-left",
            dangerouslyHTMLString: true,
          });
        });
    },
  },
};
</script>
